"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryValidator = void 0;
const ibantools = require("ibantools");
class CountryValidator {
    constructor(channel) {
        this.channel = channel;
    }
    isValidIBAN(str, strictCountryCheck = false) {
        if (strictCountryCheck && typeof str === 'string' && !str.startsWith(this.channel ?? '')) {
            return false;
        }
        return ibantools.isValidIBAN(str);
    }
    isValidPostalCode(_value, _opts) {
        throw new Error('Not implemented');
    }
    isValidPhonePassword(_value) {
        throw new Error('Not implemented');
    }
    isValidPersonalId(_value, _opts) {
        throw new Error('Not implemented');
    }
    getGenderByPersonalId(_value) {
        throw new Error('Not implemented');
    }
    normaliseIdNumber(_value) {
        throw new Error('Not implemented');
    }
}
exports.CountryValidator = CountryValidator;
/**
 * Defaults to an empty string if not overriden by the implementing class.
 */
CountryValidator.ID_CODE_MASK = '';
